<template>
  <div class="login-bg d-flex align-center justify-center">
    <v-card class="login-card pa-10" elevation="20" rounded="xl" max-width="440" width="100%">

      <!-- Brand header -->
      <div class="text-center mb-8">
        <v-avatar size="88" class="mb-4 logo-avatar">
          <v-img src="/uploads/logo.jpg" cover />
        </v-avatar>
        <h1 class="text-h5 font-weight-bold text-grey-darken-4 mb-1">Sunrise Events</h1>
        <p class="text-body-2 text-medium-emphasis">Sign in to your account</p>
      </div>

      <v-form @submit.prevent="login">
        <v-text-field
          v-model="form.email"
          label="Email address"
          type="email"
          prepend-inner-icon="mdi-email-outline"
          variant="outlined"
          density="comfortable"
          class="mb-3"
          autocomplete="email"
          :disabled="loading"
        />
        <v-text-field
          v-model="form.password"
          label="Password"
          :type="isPasswordVisible ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock-outline"
          :append-inner-icon="isPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append-inner="isPasswordVisible = !isPasswordVisible"
          variant="outlined"
          density="comfortable"
          class="mb-5"
          autocomplete="current-password"
          :disabled="loading"
        />

        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          density="compact"
          closable
          class="mb-4"
          @click:close="error = null"
        >
          {{ error }}
        </v-alert>

        <v-btn
          type="submit"
          color="grey-darken-3"
          block
          size="large"
          :loading="loading"
          rounded="lg"
          elevation="0"
        >
          <v-icon start>mdi-login-variant</v-icon>
          Sign In
        </v-btn>
      </v-form>

      <div class="text-center mt-8 text-caption text-disabled">
        &copy; {{ new Date().getFullYear() }} Sunrise Events
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isPasswordVisible: false,
      loading: false,
      form: { email: "", password: "" },
      error: null,
    };
  },
  methods: {
    async login() {
      this.error = null;
      this.loading = true;
      try {
        const response = await axios.post("/auth/login", {
          email: this.form.email,
          password: this.form.password,
        });
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        this.$router.push("/");
      } catch (err) {
        this.error =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Login failed. Please check your credentials.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.login-card {
  background: #ffffff;
}

.logo-avatar {
  border: 3px solid #e0e0e0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
</style>
